import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import {
  FloatingFilterSize, FloatingFilterType, FloatingFilterState
} from '@design-system/components/organisms/floating-filter/entities/floating-filter.types';
import { ImageSize } from '@design-system/components/molecules/image/entities/image.types';
import { TypographyColor, TypographyFontSize } from '@design-system/components/atoms/typography/entities/typography.types';
import { ImageDsComponent } from '@design-system/components/molecules/image/image.component';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';

@Component({
  selector: 'app-ds-floating-filter',
  templateUrl: './floating-filter.component.html',
  styleUrls: ['./floating-filter.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    ImageDsComponent,
    TypographyDsComponent,
  ]
})
export class FloatingFilterDsComponent {

  @Input() type = FloatingFilterType.Chip;
  @Input() size = FloatingFilterSize.RG;
  @Input() state = FloatingFilterState.Default;
  @Input() image: string;
  @Input() label: string;

  @Output() clickEvent: EventEmitter<void> = new EventEmitter<void>();

  public readonly fontSize = TypographyFontSize;
  public readonly fontColor = TypographyColor;

  constructor() { }

  get imageSize(): ImageSize {
    return this.size === FloatingFilterSize.RG ? ImageSize.RG : ImageSize.LG;
  }

}
